import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { errorMessage, listTicketRevisions, restoreTicketBody, type TicketRevision } from '../api';
import { formatWhen } from '../format';

export function BodyHistory({ ticketId, body, updatedAt, canEdit, onRestored }: {
  ticketId: number; body: string; updatedAt: string; canEdit: boolean; onRestored: () => Promise<void>;
}) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState<TicketRevision[]>([]);
  const [selected, setSelected] = useState<TicketRevision | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [more, setMore] = useState(false);
  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    void listTicketRevisions(ticketId).then(data => {
      if (!cancelled) { setRows(data); setSelected(null); setMore(data.length === 20); }
    }).catch((err: unknown) => { if (!cancelled) setError(errorMessage(err)); });
    return () => { cancelled = true; };
  }, [open, ticketId, updatedAt]);
  async function loadMore() {
    setBusy(true); setError('');
    try {
      const page = await listTicketRevisions(ticketId, rows.at(-1)?.id);
      setRows(prev => [...prev, ...page]); setMore(page.length === 20);
    } catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  }
  async function restore() {
    if (!selected) return;
    setBusy(true); setError('');
    try { await restoreTicketBody(ticketId, selected.id, updatedAt); await onRestored(); setSelected(null); }
    catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  }
  return <div className="mt-s3 text-meta">
    <Button size="sm" variant="outline" onClick={() => setOpen(!open)} aria-expanded={open}>설명 버전 이력</Button>
    {open && <div className="mt-s3 rounded-md border border-line p-s3">
      {error && <p role="alert">{error}</p>}
      {rows.length === 0 && <p>저장된 이전 버전이 없습니다.</p>}
      {rows.map(row => <Button key={row.id} size="sm" variant={selected?.id === row.id ? 'default' : 'ghost'} onClick={() => setSelected(row)}>
        {formatWhen(row.created_at)} · {row.actor_name ?? '시스템'}</Button>)}
      {more && <Button size="sm" variant="outline" disabled={busy} onClick={() => void loadMore()}>이전 버전 더 보기</Button>}
      {selected && <>
        <div className="mt-s3 grid gap-s3 min-[721px]:grid-cols-2">
          <div><strong>현재 설명</strong><pre className="max-h-[300px] overflow-auto whitespace-pre-wrap break-words">{body || '(빈 설명)'}</pre></div>
          <div><strong>선택한 이전 설명</strong><pre className="max-h-[300px] overflow-auto whitespace-pre-wrap break-words">{selected.body || '(빈 설명)'}</pre></div>
        </div>
        {canEdit && <Button size="sm" disabled={busy || selected.body === body} onClick={() => void restore()}>{busy ? '복원 중…' : '이 설명으로 복원'}</Button>}
      </>}
    </div>}
  </div>;
}
